import { render, staticRenderFns } from "./SupplierSales.vue?vue&type=template&id=6b7bca8f&scoped=true&"
import script from "./SupplierSales.vue?vue&type=script&lang=js&"
export * from "./SupplierSales.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSales.vue?vue&type=style&index=0&id=6b7bca8f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7bca8f",
  null
  
)

export default component.exports